import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import {makeStyles, useTheme, ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import { Tabs, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextInput from '../../components/TextField'
import { green, purple } from '@material-ui/core/colors';
import Joi from '@hapi/joi'
import { useForm } from 'react-final-form-hooks'
import moment from 'moment'
import httpp from "../../service/http";
import validate from '../../service/form/validation'
import formCreateInputs from '../../service/form/create'
import web3Service, {Web3, web3} from 'Backend/Web3'
// import config from '../../../config'

import ABI from "./ABI";
import Trc21ABI from "./Trc21ABI";
import Checkbox from '../../components/checkbox'
import configg from "../../../config";
import TomoZABI from "../contractInfo/TomoZABI";

const DEFAULT_FROM_DATE = moment().format('YYYY-MM-DDTHH:mm')
const DEFAULT_TO_DATE = moment().add(1, 'd').format('YYYY-MM-DDTHH:mm')
function retryGetLink (config, hash, maxRepeat = 50, repeat = 0, delay = 2000) {
    console.log('repeat', repeat)
    const http = httpp(config);
    return http.get({
        path: 'proxy-api',
        params: {url: config.exploreUrl + 'api/txs/' + hash}
    }).then(r => {
        if (r.status !== undefined) return r;
        if (repeat < maxRepeat) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return r;
    }).catch(() => {
        // console.log('error')
        if (repeat < maxRepeat) {
            // recall if api error
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return null;
    });
}
function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    roottomo: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});
export default function Tomo({config, userAuth, setTableRows, withLoading, setPageM}) {
    const http = httpp(config)
    const classes = useStyles();
    const account = userAuth.address

    const [isPass, setIsPass] = useState(false)
    const [initialInputs, updateInitialInputs] = useState({})
    const checkApprove = async (params) => {
        const web3Read = await  web3Service.web3Read()
        const contractAddress = params.tokenAddress
        const contract = new web3Read.eth.Contract(Trc21ABI, contractAddress)
        return contract.methods.allowance(account, config.contractReceiveLink).call().then(res => {
            console.log(res.toString())
            return res.toString()
        })

    }
    const checkDecimal = async (params) => {
        const web3Read = await  web3Service.web3Read()
        const contractAddress = params.tokenAddress
        const contract = new web3Read.eth.Contract(Trc21ABI, contractAddress)
        return contract.methods.decimals().call().then(res => res.toString())

    }
    const Approve = async (params) => {

        const contract = web3.eth.contract(Trc21ABI).at(params.tokenAddress);
        const amount = 100000000000000000000000000000
        const dataTx = contract.approve.getData(config.contractReceiveLink, amount);

        const rawTx = {
            to: params.tokenAddress,
            data:dataTx,
            gasPrice: 1000000000,
            gasLimit: 1000000000,
        }
        return new Promise((resolve, reject) => {
            web3.eth.sendTransaction(rawTx, (err, res) => {
                if (!err) {
                    resolve(res)
                } else {
                    console.log(err)
                    resolve(Approve(params))
                }
            })
        })


    }
    const createLink = async (params1, decimal) => {
        return new Promise((resolve, reject) => {
            const params = {...params1}
            params.password = isPass ? params1.password : config.defaultPassword
            params.fromDate = moment(params.fromDate).unix()
            params.toDate = moment(params.toDate).unix()
            const contractAddress = config.contractReceiveLink
            const contract = web3.eth.contract(ABI).at(contractAddress);
            const amount = params.amount * 10 ** decimal
            const ids = []
            const slugs = []
            for (let i = 0; i < params.num; i++) {
                ids.push(Math.floor(Math.random() * (9999999999999999999 - 1000000000000000000 + 1)) + 1000000000000000000)
                // generate slug
                let slug = ''
                const possible = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'
                for (let i = 0; i < 16; i++) {
                    slug += possible.charAt(Math.floor(Math.random() * possible.length))
                }
                slugs.push(slug);
            }
// console.log(params)
            const dataTx = contract.sendTRC21s.getData(params.num, ids, params.tokenAddress, amount, params.fromDate, params.toDate);

            const rawTx = {
                to: contractAddress,
                data: dataTx,
                from: account,
                gasPrice: 1000000000,
                gasLimit: 500000,
            }
            // console.log(params, ids, params.tokenAddress, amount, moment(params.fromDate).unix(),
            //     moment(params.toDate).unix(), params.password, rawTx)
            web3.eth.sendTransaction(rawTx, (err, res) => {
                if (!err) {
                    // console.log(res)
                    setTimeout(() => {
                        retryGetLink(config, res).then((rs) => {
                            if (rs) {
                                // console.log(rs)
                                if (rs.status == true) {
                                    const records = []
                                    for (let i = 0; i < params.num; i++) {
                                        const params1 = {...params}
                                        params1.link = config.receiveLink + slugs[i]
                                        records.push({
                                            userAddress: account,
                                            hash: res,
                                            code: ids[i].toString(),
                                            slug: slugs[i],
                                            type: 'trc21',
                                            metaData: params1,
                                            isPassword: isPass
                                        })
                                    }
                                    http.post({
                                        path: 'receive-link',
                                        payload: records
                                    }).then(() => {
                                        setPageM(0)
                                        resolve(rs)

                                    }).catch(err => {
                                        console.log('sendTRC21s - error: ', err)
                                        reject(err)
                                    });
                                } else reject(rs)
                            }
                        }).catch(err => {
                            console.log('sendTRC21s - error: ', err)
                            reject(res)
                        });

                    }, 5000)
                } else {
                    console.error(err);
                    if(err.code != 4001) createLink(params1, decimal)
                    else reject(err)
                }

            })
        })
    }
    const onSubmit = async (params) => {
        // alert()
        const allowAmount = await checkApprove(params)
        const decimal = await checkDecimal(params)
        const amount = params.amount * 10**decimal
        console.log(333, allowAmount, decimal, amount)
        if(Number(allowAmount) < amount) {
            Approve(params).then(rs => {
                // console.log(rs)
                setTimeout(withLoading(() => createLink(params, decimal), 2000))
            })
        } else await withLoading(() => createLink(params, decimal))

    }
    const schema = Joi.object().keys({
        tokenAddress: Joi.string().required(),
        num: Joi.number().integer().min(1).max(250).required(),
        amount: Joi.number().required(),
        fromDate: Joi.date().required(),
        toDate: Joi.date().required(),
        password: Joi.string().max(4).allow(null),
    })
    const { form, handleSubmit } = useForm({
        onSubmit,
        validate: validate(schema),
        initialValues: initialInputs
    })
    const [tokenAddress, num, amount, fromDate, toDate, password] = formCreateInputs(['tokenAddress', 'num', 'amount', 'fromDate', 'toDate', 'password'], form)
    useEffect(() => {
        // console.log(config)
        if(!initialInputs.num) updateInitialInputs({

            tokenAddress: config.env !== 'production' ? '0x138ceb75965f59bb1fe913fd81e75d75cb7a54cd' : '',
            num: 1,
            amount: 1,
            fromDate: DEFAULT_FROM_DATE,
            toDate: DEFAULT_TO_DATE,
            // password: '123123Aa',
        })
        // userAuth.address && withLoading(() => http.get({ path: 'receive-link/' + userAuth.address, params: {type: 'trc21'} }).then(rs => {
        //     rs.data = rs.data.map(r => {
        //         r.amount = r.metaData.amount || r.metaData.tokenIds
        //         r.fromDate = r.metaData.fromDate
        //         r.toDate = r.metaData.toDate
        //         return r
        //     })
        //     setTableRows(rs)
        // }))
        setPageM(0)
    }, [])
    const handleChangeIsPass = (status) => {
        setIsPass(status)
        // console.log(status, isPass)
    }
    return (
        <form onSubmit={handleSubmit} className={classes.roottomo} noValidate autoComplete="off">

            <div>
                <TextInput style={{width: 400}} input={tokenAddress} label="Trc21" />
                <TextInput style={{width: 100}} input={num} label="Num of link" />
                <TextInput style={{width: 100}} input={amount} label="Amount" />
                <TextInput style={{marginLeft: 15, width: 200}} input={fromDate} label='Start Time' type='datetime-local' InputLabelProps={{
                    shrink: true,
                }}/>

                <TextInput
                    input={toDate}
                    id="datetime-local"
                    label="End Time"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Checkbox checked={isPass} label={'Is Password'} handleChangeIsPass={handleChangeIsPass}/>

                {isPass && <TextInput
                    input={password}
                    id="standard-helperText"
                    type="number"
                    label="Password"
                    helperText="Receiver need this info to get, Please input exactly 4 numbers only!"
                />}
            </div>

            <ThemeProvider theme={theme}>
                <Button type='submit' variant="contained" color="primary" className={`btn ${classes.margin}`}>
                    Submit
                </Button>
            </ThemeProvider>
        </form>
    );
}
